module.exports = __webpack_public_path__ + "img/image2.4c1c4d13.webp";